import { defineComponent as _defineComponent } from 'vue';
import { BFormDatepicker, BFormInput, BInputGroup, BInputGroupAppend } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenuRanged',
    props: {
        name: null,
        identifier: null,
        error: null,
        filter: null,
        filters: null,
        disabled: { type: Boolean }
    },
    emits: ["change", "on-enter", "on-esc"],
    setup(__props, { emit }) {
        const props = __props;
        const localNameLt = computed(() => `${props.name}_lt`);
        const localNameGt = computed(() => `${props.name}_gt`);
        const valueLt = computed(() => props.filters[localNameLt.value]);
        const valueGt = computed(() => props.filters[localNameGt.value]);
        const localValueGt = ref(valueGt.value);
        const localValueLt = ref(valueLt.value);
        const isDateType = computed(() => props.filter.type == Date);
        function hasError(field) {
            if (props.error && props.error.index == field) {
                return props.error.typeError || props.error.msg;
            }
            return "";
        }
        function localPlaceholder(comp) {
            if (comp == "gt") {
                const field = isDateType.value ? "after" : "greater than";
                return `${field} ${props.filter.placeholder}`;
            }
            else {
                const field = isDateType.value ? "before" : "lower than";
                return `${field} ${props.filter.placeholder}`;
            }
        }
        watch(() => localValueGt.value, (newFilter) => {
            emit("change", localNameGt.value, newFilter);
        });
        watch(() => localValueLt.value, (newFilter) => {
            emit("change", localNameLt.value, newFilter);
        });
        watch(() => valueGt.value, (newFilter) => {
            localValueGt.value = newFilter;
        });
        watch(() => valueLt.value, (newFilter) => {
            localValueLt.value = newFilter;
        });
        return { __sfc: true, props, emit, localNameLt, localNameGt, valueLt, valueGt, localValueGt, localValueLt, isDateType, hasError, localPlaceholder, BFormDatepicker, BFormInput, BInputGroup, BInputGroupAppend };
    }
});
